var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFriends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.253 16.4766L16.003 22.6666L9.75302 16.4766C9.34077 16.0754 9.01605 15.5932 8.79931 15.0604C8.58256 14.5276 8.47849 13.9557 8.49363 13.3807C8.50878 12.8057 8.64282 12.24 8.88732 11.7194C9.13181 11.1987 9.48146 10.7343 9.91426 10.3554C10.347 9.97649 10.8536 9.69131 11.402 9.5178C11.9504 9.3443 12.5289 9.28622 13.1008 9.34724C13.6728 9.40825 14.2259 9.58703 14.7254 9.87233C15.2249 10.1576 15.6599 10.5432 16.003 11.0049C16.3476 10.5466 16.7831 10.1643 17.2823 9.88207C17.7814 9.59981 18.3334 9.42361 18.9038 9.3645C19.4742 9.3054 20.0506 9.36465 20.597 9.53856C21.1434 9.71247 21.648 9.9973 22.0793 10.3752C22.5106 10.7531 22.8592 11.216 23.1034 11.7348C23.3475 12.2537 23.482 12.8173 23.4983 13.3905C23.5146 13.9637 23.4124 14.5341 23.1981 15.0659C22.9839 15.5978 22.6621 16.0798 22.253 16.4816",
    stroke: "#1650FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0038 11L13.2596 13.7442C13.1034 13.9004 13.0156 14.1124 13.0156 14.3333C13.0156 14.5543 13.1034 14.7662 13.2596 14.9225L13.7121 15.375C14.2871 15.95 15.2204 15.95 15.7954 15.375L16.6288 14.5417C17.1261 14.0444 17.8005 13.765 18.5038 13.765C19.207 13.765 19.8815 14.0444 20.3788 14.5417L22.2538 16.4167",
    stroke: "#1650FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4141 18.9167L18.0807 20.5834",
    stroke: "#1650FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 16.8333L20.1667 18.4999",
    stroke: "#1650FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriends);
export default __webpack_public_path__ + "static/media/friends.b9bff50bf48959334e71d93ac761c709.svg";
export { ForwardRef as ReactComponent };